import * as api from '../utils/api';
export const Action = {
  INIT: 'INIT',
  SET_SCREENS: 'SET_SCREENS'
};

export function initApp(id: string) {
  return (dispatch: Cockpit.dispatch) => {
    return api
      .getApp(id)
      .then(data => {
        dispatch({
          type: Action.INIT,
          payload: {
            isLogin: true,
            id: data.tenantId,
            setting: {
              welcomeLogo: data.landing.logo,
              homeLogo: data.home.logo
            }
          }
        });
      })
      .catch(error => {
        console.log('please sign in');
        dispatch({
          type: Action.INIT,
          payload: {
            isLogin: false
          }
        });
      });
  };
}

export function getScreens() {
  return (dispatch: Cockpit.dispatch) => {
    return api.getAllScreens().then(data => {
      dispatch({
        type: Action.INIT,
        payload: {
          screens: data || [],
          screensLoading: false
        }
      });
    });
  };
}

export function updateScreen({ option, id, value }: { option: 'name' | 'publish' | 'thumb' | 'order'; id: string; value: any }) {
  return (dispatch: Cockpit.dispatch, getState: () => Cockpit.Store) => {
    const { screens } = getState();
    return api
      .updateScreen(id, {
        key: option,
        value
      })
      .then(data => {
        dispatch({
          type: Action.INIT,
          payload: {
            screens: screens.map(s => {
              if (s.id === id) {
                switch (option) {
                  case 'name':
                    s.title = value;
                    break;
                  case 'publish':
                    s.show = value;
                    break;
                  case 'thumb':
                    s.image = data.thumb;
                    break;
                }
              }
              return s;
            })
          }
        });
      });
  };
}

export function updateOrder({ id, oldIndex, newIndex }: { id: string; oldIndex: number; newIndex: number }) {
  return (dispatch: Cockpit.dispatch, getState: () => Cockpit.Store) => {
    const { screens } = getState();
    const oldItem = screens[oldIndex];
    const clone = screens.slice();
    clone.splice(oldIndex, 1);
    clone.splice(newIndex, 0, oldItem);

    dispatch({
      type: Action.INIT,
      payload: {
        screens: clone
      }
    });

    return api.updateScreen(id, {
      key: 'order',
      value: newIndex
    });
  };
}

const keyMapping = {
  welcome: 'landing',
  home: 'home'
};
export function updateStyle({ type, file }: { type: 'welcome' | 'home'; file: File }) {
  return (dispatch: Cockpit.dispatch, getState: () => Cockpit.Store) => {
    const { setting } = getState();
    return api
      .updateStyle({
        page: keyMapping[type],
        key: 'logo',
        file
      })
      .then(url => {
        dispatch({
          type: Action.INIT,
          payload: {
            setting: {
              ...setting,
              [`${type}Logo`]: url
            }
          }
        });
      });
  };
}

export function resetStyle({ type }: { type: 'welcome' | 'home' }) {
  return (dispatch: Cockpit.dispatch, getState: () => Cockpit.Store) => {
    const { setting } = getState();
    return api
      .resetStyle({
        page: keyMapping[type],
        key: 'logo'
      })
      .then(url => {
        dispatch({
          type: Action.INIT,
          payload: {
            setting: {
              ...setting,
              [`${type}Logo`]: url
            }
          }
        });
      });
  };
}
